module.exports = __webpack_public_path__ + "static/media/notebook.d2aced78.svg";